import { useCallback, useContext, useMemo } from 'react';
import Promise from 'bluebird';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { odata } from '@bingads-webui/http-util';

export function useLocationsFromMtApi(campaignApiServiceRoot, token) {
  const { scope: { values: { cid, aid } } } = useContext(ScopeContext);

  const url = useMemo(() => {
    if (cid && aid && campaignApiServiceRoot) {
      return `${campaignApiServiceRoot}/Customers(${cid})/Accounts(${aid})/Locations`;
    }
    return null;
  }, [cid, aid, campaignApiServiceRoot]);

  const getLocationsFromMtApi = useCallback((query) => {
    if (url) {
      const data = {
        $search: query,
        $expand: 'ParentLocations',
      };

      // NOTE: edm-campaign doesn't support custom query string params, call odata.get directly
      return odata.get(url, {
        data,
        headers: {
          Authorization: `CCMTSmallToken ${token}`,
        },
      });
    }

    return Promise.resolve(null);
  }, [token, url]);

  return getLocationsFromMtApi;
}
